import * as S from './FullSheet.styled';
import React from 'react';
import { Modal, Fade, styled } from '@mui/material';

interface IFullSheetProps {
  isOpen: boolean;
  children?: React.ReactNode;
}

const StyledModal = styled(Modal)`
  -webkit-overflow-scrolling: auto !important;
  overflow: auto;
`;

const FullSheet = ({ isOpen, children }: IFullSheetProps) => {
  return (
    <>
      <StyledModal open={isOpen} disableEnforceFocus>
        <Fade in={isOpen} mountOnEnter unmountOnExit>
          <S.Wrap>{children}</S.Wrap>
        </Fade>
      </StyledModal>
    </>
  );
};

export default FullSheet;
